var map = {
	"./arrow-left.svg": 3983,
	"./arrow-right.svg": 3036,
	"./bgm-cards.svg": 2477,
	"./bgm-dance-studio.svg": 9393,
	"./bgm-vertical.svg": 2859,
	"./bgm.svg": 8338,
	"./classes-offered.svg": 7910,
	"./close-icon.svg": 4178,
	"./close.svg": 2742,
	"./facebook-icon.svg": 6944,
	"./faq.svg": 5885,
	"./folder-icon.svg": 7681,
	"./follow-us.svg": 8924,
	"./guide-title.svg": 7667,
	"./guide-url.svg": 9940,
	"./hamburger.svg": 7967,
	"./highlights.svg": 361,
	"./ins-icon.svg": 3241,
	"./loading.svg": 5630,
	"./logo.svg": 8408,
	"./menu-footer.svg": 9520,
	"./menu.svg": 732,
	"./minus-icon.svg": 8172,
	"./plus-icon.svg": 175,
	"./qr-code.svg": 245,
	"./smile.svg": 5635,
	"./swipe-for-next-days.svg": 5039,
	"./swipe-for-prev-days.svg": 4431,
	"./video-icon-1.svg": 2396,
	"./video-icon-2.svg": 9849,
	"./xhs-icon.svg": 3248,
	"./youtube-icon.svg": 5
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7314;